(function () {
  'use strict';
  if (window.__adornPayUV2) return;
  window.__adornPayUV2 = true;
  var active = null;
  function mount() {
    var root = document.querySelector('[data-adorn-payu]');
    if (!root || root === active) return;
    active = root;
    var widget = root.querySelector('#payuWidget');
    var status = root.querySelector('[data-adorn-payu-status]');
    var refresh = root.querySelector('[data-adorn-payu-refresh]');
    var cents = Number(root.dataset.amountCents);
    var originalCents = cents, initialized = false, stale = false, timer, observer, unsubscribe;
    function message(text) { status.hidden = false; status.textContent = text; }
    function stopWatch() { clearTimeout(timer); if (observer) observer.disconnect(); }
    function fail() {
      stopWatch();
      if (!root.isConnected || stale) return;
      widget.hidden = true;
      message('EMI offers could not load. You can still continue to checkout.');
    }
    function variantChanged(event) {
      var data = event && event.data;
      if (!data || String(data.sectionId) !== root.dataset.sectionId || !data.variant) return;
      var next = Number(data.variant.price);
      if (!Number.isFinite(next)) return;
      cents = next;
      if (!initialized) return;
      if (next === originalCents) {
        if (stale) refresh.href = window.location.href;
        return;
      }
      stale = true;
      stopWatch();
      widget.hidden = true;
      message('Price changed. Refresh to check EMI offers for your selected option.');
      refresh.href = window.location.href;
      refresh.hidden = false;
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, variantChanged);
    function cleanup(event) {
      if (event.target && event.target.contains(root)) {
        stopWatch(); if (unsubscribe) unsubscribe();
        document.removeEventListener('shopify:section:unload', cleanup);
      }
    }
    document.addEventListener('shopify:section:unload', cleanup);
    function initialize() {
      if (!root.isConnected || !Number.isFinite(cents) || cents <= 0 || !window.AdornAssets) { fail(); return; }
      window.AdornAssets.loadScript('https://jssdk.payu.in/widget/affordability-widget.min.js', function () {
        return Boolean(window.payuAffordability && typeof window.payuAffordability.init === 'function');
      }, 'payu-affordability-sdk').then(function () {
        if (!root.isConnected) return;
        originalCents = cents;
        initialized = true;
        observer = new MutationObserver(function () {
          if (widget.childElementCount && !stale) { status.hidden = true; stopWatch(); }
        });
        observer.observe(widget, { childList: true, subtree: true });
        timer = setTimeout(fail, 15000);
        try {
          window.payuAffordability.init({ key: 'UvOjWiBd', amount: (cents / 100).toFixed(2) });
          if (widget.childElementCount && !stale) { status.hidden = true; stopWatch(); }
        } catch (error) { fail(); }
      }).catch(fail);
    }
    requestAnimationFrame(function () { setTimeout(initialize, 0); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();
